import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule } from '@angular/material/dialog';
import { MtnaDialogModule } from '@mtna/core-angular';

import { RdsFooterItemTypePipe } from './app-footer-item-type.pipe';
import { RdsAppFooterComponent } from './app-footer.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MtnaDialogModule, MatDialogModule],
  exports: [RdsAppFooterComponent, RdsFooterItemTypePipe],
  declarations: [RdsAppFooterComponent, RdsFooterItemTypePipe],
})
export class RdsAppFooterModule {}

export * from './app-footer-item-type.pipe';
export * from './app-footer.component';
